import React from "react";
import {useIntl} from "react-intl";
import {CheckCircleIcon} from "@heroicons/react/24/solid";
import {WORKSITE_REFERENCES_APPROVERS} from "../utils/constants";

const StatusReference = ({ reference, approvals, className='' }) => {

  const intl = useIntl();

  const isApproved = (target) => {
    const targetApprovals = approvals?.filter((a) => a.des_approval_type === target);
    return targetApprovals?.length > 0 && targetApprovals.every((a) => a.tms_approved_on);
  }

  const steps = [
    {
      name: 'reference_creation',
      rel_complete: !!reference,
      deferrable: false,
    },
    {
      name: 'reference_approvals_definition',
      rel_complete: reference && WORKSITE_REFERENCES_APPROVERS
        .every(({ name }) => approvals?.some((a) => a.des_approval_type === name)),
      deferrable: approvals?.some((a) => a.des_approval_type === 'progettista') ?? false,
    },
    {
      name: 'progettista_approval',
      rel_complete: isApproved('progettista'),
      deferrable: false,
    },
    {
      name: 'design_studio_approval',
      rel_complete: isApproved('CS'),
      deferrable: false,
    },
    {
      name: 'marketing_approval',
      rel_complete: isApproved('marketing'),
      deferrable: false,
    },
    {
      name: 'closed_f',
      rel_complete: true,
      deferrable: false,
    },
  ];

  return (
    <nav aria-label="Progress" className={className}>
      <ol className="space-y-4">
        {
          steps.map((step, idx, arr) => {
            const previousAllComplete = arr
              .slice(0, idx)
              .filter((s) => !s.deferrable)
              .every((s) => s.rel_complete);
            const isComplete = previousAllComplete && step.rel_complete;
            const isCurrent = idx === 0 || (previousAllComplete && !step.rel_complete);
            return (
              <li key={idx}>
                {
                  isComplete
                    ? (
                      <div className="flex items-center">
                        <span className="relative flex h-5 w-5 flex-shrink-0 items-center justify-center">
                          <CheckCircleIcon
                            className="h-full w-full text-kerakoll-700"
                            aria-hidden="true"
                          />
                        </span>
                        <span className="ml-3 text-sm font-medium text-gray-500">
                          {intl.formatMessage({id: step.name})}
                        </span>
                      </div>
                    )
                    : (
                      isCurrent
                        ? (
                          <div className="flex items-center" aria-current="step">
                            <span className="relative flex h-5 w-5 flex-shrink-0 items-center justify-center" aria-hidden="true">
                              <span className="absolute h-4 w-4 rounded-full bg-kerakoll-700 opacity-50" />
                              <span className="relative block h-2 w-2 rounded-full bg-kerakoll-700" />
                            </span>
                            <span className="ml-3 text-sm font-medium text-kerakoll-700">
                              {intl.formatMessage({id: step.name})}
                            </span>
                          </div>
                        )
                        : (
                          <div className="flex items-center">
                            <div className="relative flex h-5 w-5 flex-shrink-0 items-center justify-center" aria-hidden="true">
                              <div className="h-2 w-2 rounded-full bg-gray-300" />
                            </div>
                            <p className="ml-3 text-sm font-medium text-gray-300">
                              {intl.formatMessage({id: step.name})}
                            </p>
                          </div>
                        )
                    )
                }
              </li>
            )
          })
        }
      </ol>
    </nav>
  )
}

export default StatusReference;